import React from 'react';
import { Users as UsersIcon, Plus, Shield } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, Button } from '@plvplus/core';
import { AppRoleGuard, UnauthorizedMessage } from '../components/AppRoleGuard';

export const Users: React.FC = () => {
  return (
    <AppRoleGuard 
      requireAdmin 
      fallback={<UnauthorizedMessage message="Seuls les administrateurs peuvent accéder à la gestion des utilisateurs." />}
    >
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Gestion des utilisateurs
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Gérez les accès et permissions des utilisateurs
            </p>
          </div>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Nouvel utilisateur
          </Button>
        </div>

        <Card variant="elevated">
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <Shield className="h-5 w-5" />
              <span>Administration</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-8 text-center">
            <UsersIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
              Module d'administration
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              La gestion complète des utilisateurs sera disponible dans une prochaine version.
            </p>
            
            <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
              <p className="text-sm text-blue-800 dark:text-blue-300 mb-2">
                Fonctionnalités prévues :
              </p>
              <ul className="text-xs text-blue-700 dark:text-blue-400 space-y-1">
                <li>• Création et modification d'utilisateurs</li>
                <li>• Gestion des rôles et permissions</li>
                <li>• Audit des connexions</li>
                <li>• Paramètres de sécurité</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </AppRoleGuard>
  );
};
